<template>
  <div
    :class="{
      click: to,
    }"
    @click="goTo(to)"
  >
    <video
      v-if="isVideo"
      :src="src"
      class="img-fluid"
      muted
      playsinline
      controls
      preload="metadata"
    ></video>
    <img
      v-else
      :src="src"
      alt="Image"
      class="img-fluid"
    />
  </div>
</template>

<script>
export default {
  props: ["src", "to"],
  computed: {
    isVideo() {
      return /\.mp4($|\?)/i.test(`${this.src || ""}`);
    },
  },
  methods: {
    goTo(to) {
      if (to) {
        if (to.indexOf("http") > -1) window.open(to, "_blank");
        else this.$router.push(this.getLink(to));
      }
    },
  },
};
</script>
